import { Tenant } from "../auth/account.model";

export function showElectronicInvoiceMailInputField(tenant?: Tenant | null): boolean {
    return tenant?.invoiceDocumentFormats?.some(
        f => f === 'xrechnung' || f === 'pdf_xrechnung'
    ) ?? false;
}